package ui.campaign.detailv2.editor.wrapper

import api.AppBehavior
import common.frontend.api.Io
import playlist.ImplPlaylist
import tools.EFieldColorAsLong
import tools.EFieldDualIntAsFloat
import tools.EFieldList
import tools.EFieldMaskInt

class CampaignWrapperEApplication(
    val campaign: Io.Campaign,
    private var apps: Io.ListingApp,
) : ImplCampaignWrapperE {

    override val err: Boolean
        get() = false

    override suspend fun extractErr(): String? = null

    val actualApps get() = apps

    val adapterApps = AdapterAddedApps(campaign)

    val appBehaviorCampaignOverlap = EFieldMaskInt(
        property = campaign::appBehavior,
        mask = AppBehavior.CAMPAIGN_OVERLAP.mask,
        onChange = {
            setupAppBehavior(it)
        }
    )

    val appBehaviorReduceImpressions = EFieldMaskInt(
        property = campaign::appBehavior,
        mask = AppBehavior.REDUCE_IMPRESSIONS.mask,
        onChange = {
            setupAppBehavior(!it)
        }
    )

    private fun setupAppBehavior(overlap: Boolean) {
        if (overlap != appBehaviorCampaignOverlap.state) appBehaviorCampaignOverlap.set(overlap)
        if (!overlap != appBehaviorReduceImpressions.state) appBehaviorReduceImpressions.set(!overlap)
    }

    fun extract(): List<ImplPlaylist.AppConfig> {
        return adapterApps.state.map { item -> item.data }
    }

    class AdapterAddedApps(
        private val campaign: Io.Campaign,
    ) : EFieldList<ImplPlaylist.AppConfig, AdapterAddedApps.Item>(
        items = campaign.apps.toMutableList(),
        onBindEntry = { item ->
            Item(
                campaign = campaign,
                data = item,
            )
        }
    ) {
        class Item(
            campaign: Io.Campaign,
            override val data: ImplPlaylist.AppConfig,
            override val key: String = data.appId.toString(),
        ) : Entry<ImplPlaylist.AppConfig> {

            val conditions = ImplCampaignWrapperEConditionHeader(campaign, data.conditions)

            val colorFG = EFieldColorAsLong(data.color::fg)
            val colorBG = EFieldColorAsLong(data.color::bg)

            val codeLand = QrConfig(data.codeLand)
            val codePort = QrConfig(data.codePort)

            class QrConfig(data: ImplPlaylist.CodeConfig) {
                var size = EFieldDualIntAsFloat(data::sizePct)
                var offset = EFieldDualIntAsFloat(data::offsetPct)
                var x = EFieldDualIntAsFloat(data::xPct)
                var y = EFieldDualIntAsFloat(data::yPct)
            }
        }
    }

    fun addApp(item: Io.ListingApp.Item) {
        adapterApps.add(
            index = 0,
            newItem = ImplPlaylist.AppConfig(
                appId = item.id,
                name = item.name,
                logo = item.logo
            )
        )
    }
}